import { FC } from "react"

import { PromotionBlock } from "./types/types"
import { BlockRenderer } from "./BlockRenderer"

type Props = {
  blocks: PromotionBlock[]
  onUpdateBlock: (id: string, patch: Partial<PromotionBlock>) => void
  onMove: (id: string, direction: "up" | "down") => void
  onRemove: (id: string) => void
}

export const BlockList: FC<Props> = ({ blocks, onUpdateBlock, onMove, onRemove }) => {
  if (!blocks.length) {
    return <p className="text-xs opacity-70 mt-2">No blocks yet. Add one above to get started.</p>
  }

  return (
    <div className="space-y-4 mt-3">
      {blocks.map((block, index) => (
        <div key={block.id} className="border border-[rgba(255,255,255,0.12)] rounded-lg p-4 bg-[#050816]">
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs uppercase opacity-60">
              {index + 1}. {block.type}
            </span>
            <div className="flex gap-2">
              <button type="button" className="btn btn-xs btn-ghost" onClick={() => onMove(block.id, "up")} disabled={index === 0}>
                ↑
              </button>
              <button
                type="button"
                className="btn btn-xs btn-ghost"
                onClick={() => onMove(block.id, "down")}
                disabled={index === blocks.length - 1}
              >
                ↓
              </button>
              <button type="button" className="btn btn-xs btn-error" onClick={() => onRemove(block.id)}>
                Delete
              </button>
            </div>
          </div>

          <BlockRenderer block={block} onChange={(patch) => onUpdateBlock(block.id, patch)} />
        </div>
      ))}
    </div>
  )
}
